export default data => {
  let value = null;

  try {
    value = JSON.parse(data);
  } catch (e) {}

  return value;
};



// WEBPACK FOOTER //
// ./src/utils/parseJSONSafely.js